import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';
import { MenuItem } from '../components/styled';
import MessageSection from '../components/MessageSection';

const faqs = [
	{
		title: 'How much commission will I get?',
		description: 'Commissions will vary month to month depending on how many transactions are done. Commission per transaction also vary depending on the size of the transaction.',
	},
	{
		title: 'Do I need to pay something to have blueshyft?',
		description: 'No, blueshyft is completely free for agents, there are no fees included.',
	},
	{
		title: 'What standards do I have to meet to become blueshyft agent?',
		description: 'Ensure staff are trained, comply with opening hours advised when signing up, ensure funds are available for direct debit sweep from the nominated bank account bi-weekly, securely store cash in cash register and/or safe and provide impeccable customer service.',
	},
	{
		title: 'Do I have to have all services listed or I can only pick what I want to offer?',
		description: 'You do not have to offer all services. It will be automatically enabled on your iPad.',
	},
	{
		title: 'How will I get trained to use the platform?',
		description: 'Once you signed the contract and while hardware is on the way, we will send you blueshyft Operations Manual which includes cheat sheet of every transaction and training videos as well.',
	},
	{
		title: 'How can I make sure nobody will process any transactions if I’m away from the counter?',
		description: 'When signing in to the iPad for the first time, you will have to create a 4 digit PIN number which will only allow you and your staff members to finalise transactions and nobody else.',
	},
	{
		title: 'How long do I have to wait until I receive the hardware?',
		description: 'The hardware should arrive within two weeks after you signed the online contract.',
	},
	{
		title: 'What details will I have to provide when signing up?',
		description: 'We will need your shop name, address, opening hours and phone number. Also your full name, business name, ABN and bank details.',
	},
];

class Tab extends Component {
	constructor (props) {
		super(props);

		this.state = { checked: false };
	}

	render () {
		const { faq } = this.props;

		return (
			<TabContainer onClick={() => this.setState({ checked: !this.state.checked })}>
				<TabDiv>
					<Label>{faq.title}</Label>
					{/* <div style={{ display: 'flex', alignItems: 'center', fontSize: 20, color: '#505d68' }}>{faq.title}</div> */}
					<div style={{ width: 24, height: 24 }}>
						<Image src={ this.state.checked ? '/images/redesign/icon-faq-close.png' : '/images/redesign/icon-faq.png' } style={{ width: 24, height: 24 }} />
					</div>
				</TabDiv>
				<Content
					maxHeight={this.state.checked ? '100vh' : 0}
				>
					<div style={{ marginTop: 15, color: '#a1aeb7', width: '95%' }}>{faq.description}</div>
				</Content>
			</TabContainer>
						// <div style={{ border: '1px solid #dadada', borderRadius: 5, padding: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
						// 	<div style={{ display: 'flex', alignItems: 'center', fontSize: 20, color: '#505d68' }}>{faq.title}</div>
						// 	<div style={{ width: 24, height: 24 }}><Image src="/images/redesign/icon-faq.png"/></div>
						// 	{/* <div>{faq.description}</div> */}
						// </div>
		);
	}
}

export default class ContactUs extends Component {
	render () {
		const { REACT_APP_GOOGLE_API_KEY } = process.env;

		return (
			<div>
				<Helmet
					title="FAQs"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<MessageSection
					style={{ marginTop: '50px' }}
					header="Frequently Asked Questions"
					paragraph1="Answers to the most common questions about the blueshyft platform"
				/>
				<div style={{ maxWidth: 946, margin: 'auto' }}>
					{faqs.map(faq => (
						<Tab faq={faq} />
					))}
				</div>
				<div style={{ height: 150 }} />
			</div>
		);
	}
};

const Content = styled.div`
	max-height: ${props => props.maxHeight};
	overflow: hidden;
	-webkit-transition: ${props => props.maxHeight !== 0 ? 'max-height .35s' : 'max-height .1s'};
	-o-transition: ${props => props.maxHeight !== 0 ? 'max-height .35s' : 'max-height .1s'};
	transition: ${props => props.maxHeight !== 0 ? 'max-height .35s' : 'max-height .1s'};
`;

const Label = styled.div`
	display: flex;
	align-items: center;
	font-size: 20;
	color: #505d68;
`;

const TabContainer = styled.div`
	border: 1px solid #dadada;
	border-radius: 5px;
	padding: 20px;
	margin: 15px;
`;

const TabDiv = styled.div`
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

const TextArea = styled.textarea`
	color: #c2d2d9;
	&::-webkit-input-placeholder {
		color: #c2d1d9;
	}
`;

// const Input = styled.input`
// 	color: #c2d2d9;
// 	&::-webkit-input-placeholder {
// 		color: #c2d1d9;
// 	}
// `;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;

const InputContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/Faqs/index.js